export const GET_ALL_MARKER_GROUPS = "GET_ALL_MARKER_GROUPS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_MARKER_GROUPS = "START_LOADING_MARKER_GROUPS";
export const STOP_LOADING_MARKER_GROUPS = "STOP_LOADING_MARKER_GROUPS";
export const ERROR_LOADING_MARKER_GROUPS = "ERROR_LOADING_MARKER_GROUPS";